var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[(_vm.content)?_c('Content',[_c('div',{staticClass:"box",domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }